import { FC, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SpeculationRule from '../../entity/SpeculationRule';
import { Organization } from '@kaizenplatform/intelligence-entity';
import { PageContainer, PageHeader, PageTitle } from '../component/primitive/Page';
import { Tabs, Tab, Box } from '@material-ui/core';
import { LinkPrefetchReportTab, LinkPrefetchEditTab } from '../component/compound/LinkPrefetch';

type Props = {
  organization: Organization | null;
  speculationRule: SpeculationRule | null;
  speculationRuleLoading: boolean;
  getSpeculationRule: () => void;
  putSpeculationRule: (speculationRule: SpeculationRule) => void;
  onMount: () => void;
};

type TabValue = 'report' | 'edit';

function TabPanel(props: { children?: React.ReactNode; tab: TabValue; value: TabValue }) {
  const { children, tab, value } = props;

  return (
    <Box role="tabpanel" hidden={tab !== value} id={`tabpanel-${tab}`} aria-labelledby={`tab-${tab}`}>
      {children}
    </Box>
  );
}

const LinkPrefetchPage: FC<Props> = ({
  organization,
  speculationRule,
  speculationRuleLoading,
  getSpeculationRule,
  putSpeculationRule,
  onMount,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = tabParam === 'edit' ? 'edit' : 'report';
  const [tabValue, setTabValue] = useState<TabValue>(initialTab);

  const handleTabChange = (_: React.ChangeEvent<Record<string, never>>, newValue: TabValue) => {
    setTabValue(newValue);
    searchParams.set('tab', newValue.toString());
    setSearchParams(searchParams);
  };

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>リンク先読み</PageTitle>
      </PageHeader>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        style={{ marginTop: 12, borderBottom: '2px solid #e0e0e0' }}
      >
        <Tab label="レポート" value="report" style={{ fontWeight: 'bold', fontSize: 'medium' }} />
        <Tab label="設定情報" value="edit" style={{ fontWeight: 'bold', fontSize: 'medium' }} />
      </Tabs>
      <TabPanel tab="report" value={tabValue}>
        <LinkPrefetchReportTab organization={organization} speculationRule={speculationRule} speculationRuleLoading={speculationRuleLoading} />
      </TabPanel>
      <TabPanel tab="edit" value={tabValue}>
        <LinkPrefetchEditTab
          organization={organization}
          speculationRule={speculationRule}
          getSpeculationRule={getSpeculationRule}
          putSpeculationRule={putSpeculationRule}
          speculationRuleLoading={speculationRuleLoading}
          onMount={onMount}
        />
      </TabPanel>
    </PageContainer>
  );
};

export default LinkPrefetchPage;
